export const routesMap = {
  home: { en: "/home", ar: "/الرئيسية" },
  about: { en: "/about-us", ar: "/من-نحن" },
  contact: { en: "/contact", ar: "/تواصل-معنا" },
  service: { en: "/service", ar: "/الخدمات" },
  projects: { en: "/projects", ar: "/الأعمال" },
  policies: { en: "/policies", ar: "/السياسات" },
  serviceDescription: { en: "/service/:slug", ar: "/الخدمات/:slug" },
}; 